module.exports = __webpack_public_path__ + "media/images/version_merge/google_play_btn-5b266aefdc341bc2bec489fd01ae06d0.png";